export default __webpack_public_path__ + "img/chefsmaak-logo-circular.png";